// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__X452F","right":"styles_right__zkiXI"};